import type { ReaderName } from "@bindery/shared/contracts/session";
import { signIn } from "@bindery/auth-consumer/browser";
import { bindReaderThrough } from "./bind-reader";
import { useSession } from "./use-session";

export interface BoundReader {
  /** `null` until signed in with a reader bound. */
  boundReader: ReaderName | null;
  /** Navigates away through the broker and returns bound to `readerId`. */
  bindReader: (readerId: string, returnTo?: string) => void;
}

function bindReader(readerId: string, returnTo?: string): void {
  bindReaderThrough(signIn, readerId, returnTo);
}

export function useBoundReader(): BoundReader {
  const session = useSession();
  return {
    boundReader: session.status === "signed-in" ? session.boundReader : null,
    bindReader,
  };
}
